<template>
    <div>
        <div class="detail-card">
          <h6><b>Product Types / Groups</b></h6>
          <p>for product groups or types eg. colors, materials, plans, sizes etc</p>
          <!--product-set-settings-->
          <div class="card card-colord-pad card-colord-01" style="margin-top:1.5em;">
            <!-- <div v-if="product_details.setProductSettings"> -->
            <div class="">
                <!-- <h5 style="font-size: 12px; font-weight: bold;">General Product Group and Group Items Name</h5> -->
                <!-- <p>This is a general name of this Product's Grouping, you may change it whenever you want</p> -->
                <p><b>Group Name: </b><span style="color:blue">{{product.product_groups_set_name}}</span> <span style="font-size: 12px;">(eg: Colours)</span></p>
                <p><b>Sub Group Name: </b><span style="color:blue">{{product.product_groups_items_set_name}}</span><span style="font-size: 12px;">(eg: Sizes)</span></p>
                <!-- <p><b>Group Items Name: </b><span style="color:blue">{{product.product_groups_items_set_name}}</span></p> -->
                <!-- <button class="btn sp-button-02 sp-button-sm" style="line-height:0.8" @click="setProductComponent('setProductSettings','','')"> Change this Name</button> -->
                <button class="btn sp-button-02 sp-button-sm" style="line-height:0.8" @click="setProductComponent('setProductSettings','','')"> Change Group Name and Sub Group Name</button>
                <!-- <button class="btn sp-button-02 sp-button-sm" style="line-height:0.8; float: right;" @click="setProductComponent('hide-settings-box','','')"> Hide</button> -->
                <br>
            </div>
            <div v-if="product_details.setProductSettings">
              <div class="form-group col-md-6">
                  <label style="display:inline;"><b>Group Name: </b><span style="font-size: 12px;">(eg: Colours)</span><input type="text" v-model="product.product_groups_set_name" class="form-control"></label>
              </div>
              <div class="form-group col-md-6">
              <!-- <div class="form-group col-md-6" v-if="product.product_set_items > 0"> -->
                  <b>Group Items Name: </b><span style="font-size: 12px;">(eg: Sizes)</span><input type="text" v-model="product.product_groups_items_set_name" class="form-control">
              </div>
              <div class="col-md-6">
                  <div v-if="action_loading" class="loading-sm"></div>
                  <p style="color:#ff0000;">{{data_processing_message}}</p>
                  <button class="btn sp-button-02 sp-button-md" type="button"  @click="editProductSettings">Save</button> 
                  <button class="btn sp-button-02 sp-button-md" type="button"  @click="setComponent('reset-edit','')"><i class="fa fa-ban"></i> Cancel</button>
              </div>
              <div class="clearfix"></div>
              <hr/>
            </div>
            <div class="card card-out-colord-pad" v-if="!product_details.addProductItemPanel">
                <!-- <p>add other variations like groups or types of this product eg. colors, materials, plans, sizes etc</p> -->
                <!--product-variation-default-set-names-->
                <!-- <div style="float: right; margin-bottom: 1em;">
                  <button class="btn sp-button-02 sp-button-md" style="line-height:1.2" @click="setProductComponent('show-settings-box','','')"><i class="fa fa-gear"></i> Settings </button>
                </div> -->
                <!-- <div v-if="show_product_setting_box" class="sp-info-text-box">
                  <h5 style="font-size: 12px; font-weight: bold;">General Product Group and Group Items Name</h5>
                  <p>This is a general name of this Product's Grouping, you may change it whenever you want</p>
                  <p><b>Group Name: </b><span style="color:blue">{{product.product_groups_set_name}}</span></p>
                  <p><b>Group Items Name: </b><span style="color:blue">{{product.product_groups_items_set_name}}</span></p>
                  <button class="btn sp-button-02 sp-button-sm" style="line-height:0.8" @click="setProductComponent('setProductSettings','','')"> Change this Name</button>
                  <button class="btn sp-button-02 sp-button-sm" style="line-height:0.8; float: right;" @click="setProductComponent('hide-settings-box','','')"> Hide</button>
                  <br>
                </div> -->
                
                <div v-if="product.product_set_groups == 0">
                  <!-- <p><b>{{product.product_groups_set_name}}</b>
                    <button class="btn sp-button-02 sp-button-sm" style="line-height:0.8" @click="setProductComponent('setProductSettings','','')"> Change this Name</button>
                  </p> -->
                </div>
                <div style="margin:1em 0; display: none;">
                  <button class="btn sp-button-02" style="line-height:1.2" @click="setProductComponent('addProductItemPanel','','')"><i class="fa fa-plus"></i> Add Product Variation</button>
                </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!--./product-set-settings-->
          
          <!--product-groups-and-items-->
          <div class="card card-out-colord-pad" style="margin-top:1.5em;" v-if="!product_details.addProductItemPanel">
            <button class="btn sp-button-02 sp-button-sm" style="float: right; line-height:1.2" @click="setProductComponent('addProductItemPanel','','')">Add new Group</button>
            <h5 class="" style="margin-bottom: 1em;">Product Groups/Types </h5>
            <div class="clearfix"></div>
            <div v-if="((product.product_set_groups > 0) && (product.product_set_items > 0))" style="">
              <div class="card card-flat-pad" v-for="(pg,pgdex) in product.product_item_groups" :key="pg.id" style="border: #f7f7f7 solid !important;">
                <div style="float:left; width:90%;">
                  <div>
                    <!-- <span style="float:left; width: 55%;"><b>{{product.product_groups_set_name}}</b></span> -->
                    <!-- <span style="float:left; width: 55%;"><b>{{pg.product_item_group_name}}</b></span>-->
                    <span style="float:right;">  {{Object.keys(pg.product_items).length}} items</span>
                    <div class="box-cube" style="">
                      <div class="box-color-cube" v-if="pg.product_item_group_is_color_image == 'IMG'" style="z-index: 3;">
                        <img v-if="(pg.product_item_group_image && (pg.product_item_group_image != 'error'))" :src="pg.product_item_group_image" class="sp-prd-img"/>
                        <img v-else src="/static/assets/images/dummy-image.png" class="sp-prd-img"/>
                      </div>
                      <div v-if="pg.product_item_group_is_color_image == 'COL'">
                        <div class="box-color-cube" v-bind:style="{background: pg.product_item_group_color}"></div>
                      </div>
                      <!-- <div class="clearfix"></div> -->
                      <!-- <button class="btn v-tiny-btn sp-button-02 sp-button-sm" style="z-index: 9;" type="button"  @click="toggleSingleComponent('pgset'+pgdex)"><i class="fa fa-gear"></i></button> -->
                      <div class="clearfix"></div>
                    </div>
                    <div style="margin-top: -1.5em;"><b>{{pg.product_item_group_name}}</b></div>
                   <div style="clear:both;"></div>
                  </div>
                </div>
                <div style="float:right;">
                  <div>
                    <a v-if="menu_tab_inner_view['PGITMS'+pgdex]" style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('')">
                      <div class="">
                        <i class="fa fa-angle-down"></i>
                      </div>
                    </a>
                    <a v-else style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('PGITMS'+pgdex)">
                      <div class="">
                        <i class="fa fa-angle-down"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div style="clear: both;"></div>
                <div v-if="menu_tab_inner_view['PGITMS'+pgdex]">
                  <div class="orders-panel" style="margin-top:1em;">
                    <div v-if="(!product_details.editProductItemGroup && !product_details.removeItemGroup && !product_details.addProductItemToGroup)">
                      <div class="card card-strip">
                        <span><a style="cursor: pointer;" class="sp-app-default-color" @click="setProductComponent('editProductItemGroup','productitemgroup',pg)">Edit Group</a></span> &nbsp;&nbsp;
                        <span v-if="product.product_item_groups && product.product_item_groups.length > 1"><a style="cursor: pointer;" class="sp-app-default-color" @click="setProductComponent('removeItemGroup','productitemgroup',pg)">Delete group</a></span>
                      </div>
                      <!-- <p style="text-align:center; font-weight:bolder; font-size:18px;"> . . .</p> -->
                      
                      <!--items-group-->
                      <div class="">
                        <div style=""> 
                          <!-- <h5 style="font-size:10px; text-transform:capitalize"><span v-if="product.product_service == 'P'">Sizes in this Colour:</span>
                          <span v-if="product.product_service == 'S'">Service Packages:</span></h5> -->
                          <h5 style="font-size:10px; text-transform:capitalize">{{product.product_groups_items_set_name}}
                              <!-- <button class="btn btn-xs v-tiny-btn sp-button-02 sp-button-sm" style="line-height:0.8" @click="setProductComponent('setProductSettings','','')"> Change</button> -->
                          </h5>
                          <div class="items-list-tiny" v-for="(pt,ptdex) in pg.product_items" :key="ptdex" style="display:inline;">
                            <!-- <a class="box-wrap" style="cursor:pointer;" @click="setComponent('set-product-item',pt)"> -->
                            <!--view-item-->
                            <div class="row" style="padding: 1em;">
                              <div class="box-cube col-xs-2 mp-flat" style="margin:0; padding: 0;">
                                <div class="box-color-cube" v-if="pg.product_item_group_is_color_image == 'IMG'" style="z-index: 3;">
                                  <img v-if="(pg.product_item_group_image && (pg.product_item_group_image != 'error'))" :src="pg.product_item_group_image" class="sp-prd-img"/>
                                  <img v-else src="/static/assets/images/dummy-image.png" class="sp-prd-img"/>
                                </div>
                                <div v-if="pg.product_item_group_is_color_image == 'COL'">
                                  <div class="box-color-cube" v-bind:style="{background: pg.product_item_group_color}"></div>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div class="col-xs-9 mp-flat" style="margin:0; padding: 0;">
                                <span style="font-weight: bolder; font-size: 10px;" v-if="product.product_service == 'P'  && (pt.product_item_size)">{{pt.product_item_size}}</span>
                                <span style="font-weight: bolder; font-size: 10px;"  v-if="product.product_service == 'S' && (pt.product_item_service_tag)">{{pt.product_item_service_tag}}</span>
                                <span><a style="cursor: pointer; font-size: 10px;" class="sp-app-default-color"  @click="setProductComponent('editProductItem','productitem',pt)">Edit</a>
                                </span>
                                <span v-if="product.product_items.length > 1"><a style="cursor: pointer; font-size: 10px;" class="sp-app-default-color" @click="setProductComponent('removeProductItem','productitem',pt)">Delete</a>
                                </span>
                                <br>
                                <p style="font-size: 11px;">
                                  <span v-if="product.product_service == 'P'"><span><b>Wt(kg):</b></span>{{pt.product_item_weight}}</span> 
                                  <span v-if="pt.product_item_actual_price != 0"><span><b>Price:</b></span>{{pt.product_item_actual_price}}</span>
                                  <span v-else><span><b>Price:</b></span>{{pt.product_item_price}}</span>
                                  <span><span><b>Qty:</b></span>{{pt.product_item_quantity}}</span>
                                </p>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                            <!--./view-item-->

                            <!--edit-item-->
                            <div id="editProductItem" v-if="product_details.editProductItem && (product_item.product_item_id == pt.product_item_id)" class="col-sm-12" style="margin-top:1em; margin-bottom: 1em;">
                              <h6 align="left">Edit Product Item</h6>
                              <form class="sp-form">
                                <div class="row">
                                  <div class="form-group col-xs-6">
                                    <label> <span v-if="product.product_service == 'P'"> Size</span><span v-if="product.product_service == 'S'"> Type</span>
                                      <input class="form-control" type="text" v-model="product_item.product_item_size" value="" placeholder="">
                                    </label>
                                  </div>
                                  <div class="form-group col-xs-6" v-if="product.product_service == 'S'">
                                    <label> Service Tag
                                      <input class="form-control" type="number" v-model="product_item.product_item_service_tag"  placeholder="">
                                    </label>
                                  </div>
                                    <div class="form-group col-xs-6">
                                          <label> Price
                                            <input v-if="product_item.product_item_actual_price != 0" class="form-control" type="number" v-model="product_item.product_item_actual_price" value="" placeholder="">
                                            <input v-else class="form-control" type="number" v-model="product_item.product_item_price" value="" placeholder="">
                                          </label>
                                      </div>
                                      <div class="form-group col-xs-6">
                                        <label> Weight
                                          <input class="form-control" type="number" step="any" v-model="product_item.product_item_weight"  placeholder="">
                                        </label>
                                      </div>
                                      <div class="form-group col-xs-6">
                                        <label> Quantity
                                          <input class="form-control" type="number" v-model="product_item.product_item_quantity"  placeholder="">
                                        </label>
                                      </div>
                                      <div class="col-md-3 col-xs-12" v-if="product.product_service == 'S'">
                                        <label> Duration <span class="sp-info-sm">eg: 3 months</span> </label><br>
                                        <label v-if="product_item.product_item_service_duration != ''"><b>SET: {{product_item.product_item_service_duration}}</b></label>
                                        <table style="width: 100%;"><tr>
                                          <td style="width: 30%;">
                                            <input type="number" style="width: 100%;" v-model="product.product_item_service_duration" placeholder="" class="form-control">
                                          </td>
                                          <td style="width: 70%;">
                                            <select v-model="service_duration" class="form-control">
                                              <option :value="undefined">Select</option>
                                              <option>days</option>
                                              <option>months</option>
                                              <option>years</option>
                                            </select>
                                        </td>
                                        </tr></table>
                                      </div>
                                    <!-- <hr/> -->
                                      <div class="col-md-12 col-xs-12">
                                          <div v-if="action_loading" class="loading-sm"></div>
                                          <p style="color:#ff0000">{{data_processing_message}}</p>
                                          <button :disabled="disable_btn" class="btn sp-button-02 sp-button-md" type="button" style="line-height:1.2; margin-right:5px;"  @click="editProductItem">Save</button>
                                          <button class="btn sp-button-02 sp-button-md" type="button" style="line-height:1.2; margin-right:5px;" @click="setComponent('reset-edit','')"><i class="fa fa-ban"></i> Cancel</button>
                                      </div>
                                      <br>
                                      <hr/>   
                                </div>
                              </form>
                              <div  class="clearfix"></div>
                            </div>
                            <!--./edit-item-->

                            <!--delete-itm-->
                            <div>
                              <!-- <a class="pull-right" style="cursor:pointer; line-height:0.8;" @click="setComponent('remove-product-item','')"><span  style="text-decoration:underline;">Remove this Item <i class="fa fa-trash"></i></span></a> -->
                              <span class="" v-if="product_details.removeProductItem && (product_item.product_item_id == pt.product_item_id)">
                                <p style="color:#ff0000">Do you really want to remove this Item?</p>
                                <button :disabled="disable_btn" class="btn btn-xs sp-button-02 sp-button-sm" @click="removeProductItem()">Yes</button>
                                <button class="btn btn-xs sp-button-02 sp-button-sm" @click="setComponent('reset-edit','')">Cancel</button>
                                <div v-if="action_loading" class="loading-sm"></div>
                              </span>
                            </div>
                            <!--./delete-itm-->

                            <!-- <a v-if="edit_mode" href="#editProductItem" style="margin-top:-3em; font-size:10px; padding:6px" type="button" class="btn pull-right" @click="setComponent('set-edit-product-item',pt)"><i class="fa fa-pencil"></i></a> -->
                          </div>
                          <!-- not-used since adding product item takes care of independent ites (eg. sizes, subscription_plans)
                            <a v-if="product.product_service == 'P'" class="btn btn-xs v-tiny-btn" type="button"  @click="setComponent('reset-edit','')"> <i class="fa fa-plus"></i> Add new size</a>
                          <a v-if="product.product_service == 'S'" class="btn btn-xs v-tiny-btn" type="button"  @click="setComponent('reset-edit','')"> <i class="fa fa-plus"></i> Add new type</a> -->
                          <br>
                          <button class="btn btn-xs sp-button-02 sp-button-sm" style="float: right;" @click="setProductComponent('addProductItemToGroup','productitemgroup',pg)"> Add New Item</button>
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                      <!--./items-group-->
                    </div>

                    <!--edit-and-delete-product-item-group-->
                    <div class="" v-if="product_details.editProductItemGroup || product_details.removeItemGroup">
                      <!--edit-->
                      <div id="editProductItemGroup" v-if="product_details.editProductItemGroup && (product_item_group.product_item_group_id == pg.product_item_group_id)" class="col-sm-12" >
                        <!-- <button class="btn sp-button-02 sp-button-sm" type="button" style="float: right; line-height:1.2;" @click="setComponent('reset-edit','')"><i class="fa fa-ban"></i> Cancel</button> -->
                        <h6 class="sp-app-default-color">Edit Group </h6>
                        <div class="row">
                          <div class="form-group col-xs-12">
                            <label>Name</label>
                            <input type="text" v-model="product_item_group.product_item_group_name" class="form-control">
                          </div>
                          <div class="form-group col-xs-12">
                            <p>Group Label (Colour/Image)</p>
                            <div class="box-cube">
                              <div class="" v-if="product_item_group.product_item_group_is_color_image == 'IMG'">
                                <img v-if="(product_item_group.product_item_group_image && (product_item_group.product_item_group_image != 'error'))" :src="product_item_group.product_item_group_image" class="sp-prd-img"/>
                                <img v-else src="/static/assets/images/dummy-image.png" class="sp-prd-img"/>
                              </div>
                              <div v-if="product_item_group.product_item_group_is_color_image == 'COL'">
                                <div class="box-color-cube" v-bind:style="{background: pg.product_item_group_color}"></div>
                              </div> 
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div class="form-group col-xs-12">
                            <label class="sp-app-default-color">To change Group Label, pick Colour or Image</label>
                          </div>
                          <div class="form-group col-xs-12">
                            <label class="col-xs-4" style="margin: 0; padding: 0;">
                              <input type="radio" name='prt-color-image' @click="toggleDoubleComponent('prt-color-edit','prt-image-edit')" value="colour" style="height:1em;">
                              Colour
                            </label>
                            <label class="col-xs-4" style="margin: 0; padding: 0;">
                              <input type="radio" name='prt-color-image' @click="toggleDoubleComponent('prt-image-edit','prt-color-edit')" value="image" style="height:1em;">
                              Image
                            </label>
                          </div>
                          <div class="form-group col-xs-12" id="prt-color-edit" style="clear:both; display: none;  padding:1em;">
                            <label class="sp-app-default-color"> Select a Colour </label>
                            <input type="color" v-model="product_item_group.product_item_group_color_new"  class="form-control" style="width:4em;">
                          </div>
                          <div class="form-group col-xs-12" id="prt-image-edit" style="clear:both; display: none;  padding:1em;">
                            <div v-if="product.product_images && (Object(product.product_images).length > 0)">
                              <label>Pick Image</label>
                              <div class="row img-row">
                                  <div id="groupImage" class="col-xs-1" v-for="(img,index) in product.product_images" :key="index" style="height:40px; width:100px; margin-bottom: 5px;">
                                    <a style="cursor:pointer;" @click="setInnerComponent('set-product-item-group-image',img.product_image_id)">
                                      <img :id="img.product_image_id+'PRTG'" class="product-item-group-image sp-prd-img" :src="img.product_image"  alt="">
                                    </a>
                                  </div>
                              </div>
                              <hr/>
                            </div>
                            <div class="clearfix"></div>
                            <div class="" style="z-index:9">
                              <div id="uploadDiv" class="upload-btn-wrapper" style="cursor:pointer;">
                                <button class="upload-btn sp-button-02 sp-button-md" style="line-height:1.2">Add new Image</button>
                                <input type="file" id="input-file" @change="onFileChange($event,'products',product.product_id)" accept="image/*"/>
                              </div>
                            </div><hr/>
                          </div>
                          <div class="form-group col-xs-12">
                              <div v-if="action_loading" class="loading-sm"></div>
                              <p style="color:#ff0000">{{data_processing_message}}</p>
                              <button :disabled="disable_btn" class="btn sp-button-02 sp-button-md" type="button" style="line-height:1.2; margin-right:5px;"  @click="editProductItemGroup">Save</button>
                              <button class="btn sp-button-02 sp-button-md" type="button" style="line-height:1.2; margin-right:5px;" @click="setComponent('reset-edit','')"><i class="fa fa-ban"></i> Cancel</button>
                          </div>    
                        </div>
                      </div>
                      <!--./edit--->
                      <!--delete-->
                      <div class="" v-if="product_details.removeItemGroup && (product_item_group.product_item_group_id == pg.product_item_group_id)">
                        <span class="">
                          <p style="color:#ff0000">Do you really want to remove this Group?</p>
                          <button class="btn btn-xs sp-button-02 sp-button-sm" @click="removeProductItemGroup()">Yes</button>
                          <button class="btn btn-xs sp-button-02 sp-button-sm" @click="setComponent('reset-edit','')">Cancel</button>
                          <div v-if="action_loading" class="loading-sm"></div>
                        </span>
                      </div>
                      <!--./delete-->
                    </div>
                    <!---edit-and-delete-product-item-group-->
                  
                    <!--add-new-product-item-to-group-->
                    <div class="row" v-if="product_details.addProductItemToGroup && (product_item_group.product_item_group_id == pg.product_item_group_id)">
                        <!-- <div class="col-md-12"><label><h4 style="font-size:14px;">Enter Details of New Group Item</h4></label></div> -->
                        <div class="col-md-6 col-xs-12" v-if="product.product_service == 'P'">
                          <label>Attributes (eg: Size, Plan, Length etc,)
                              <input type="text" v-model="product.product_item_size"  placeholder="" class="form-control">
                          </label>
                        </div>

                        <div class="col-md-4 col-xs-4" v-if="product.product_service == 'S'">
                            <label> Service Tag
                                <input type="text" v-model="product.product_item_service_tag"  placeholder="" class="form-control">
                            </label>
                        </div>

                        <div class="col-md-3 col-xs-4">
                            <label> Price
                                <input type="number" v-model="product.product_item_price" value="" placeholder="" class="form-control">
                            </label>
                        </div>
                        
                        <div class="col-md-3 col-xs-4" v-if="product.product_service == 'P'">
                            <label> Weight(KG)
                                <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" class="form-control">
                            </label>
                        </div>

                        <div class="col-md-3 col-xs-4">
                            <label> Quantity
                                <input type="number" v-model="product.product_item_quantity"  placeholder="" class="form-control">
                            </label>
                        </div>

                        <div class="col-md-3 col-xs-6" v-if="product.product_service == 'S'">
                          <label> Duration <span class="sp-info-sm">eg: 3 months</span> </label>
                          <table style="width: 100%;"><tr>
                            <td style="width: 30%;">
                              <input type="number" style="width: 100%;" v-model="product.product_item_service_duration" placeholder="" class="form-control">
                            </td>
                            <td style="width: 70%;">
                              <select v-model="service_duration" class="form-control">
                                <option :value="undefined">Select</option>
                                <option>days</option>
                                <option>months</option>
                                <option>years</option>
                              </select>
                          </td>
                          </tr></table>
                        </div>

                        <div class="clearfix"></div>
                        <div class="col-md-6 col-xs-12">
                            <p class="data-error-message">{{data_error_message}}</p>
                            <p class="data-success-message">{{data_success_message}}</p>
                            <div v-if="action_loading" class="loading-sm"></div>
                            <button :disabled="disable_btn" type="button" class="btn sp-button-02 sp-button-md" @click="addProductItem">Add Item</button>
                            <button class="btn sp-button-02 sp-button-md" @click="setComponent('reset-edit','')">Cancel</button>
                        </div>
                    </div>
                    <!--./add-new-product-item-to-group-->

                  </div>
                </div>
              </div>
            </div>
            <div v-else style="margin:5px 0.89em">
              <p class="sp-app-default-color">You have not set any Product item variation</p>
            </div>
          </div>
          <!--product-groups-and-items-->

          <!---add-product-variation-->
          <div class="" v-if="product_details.addProductItemPanel">
            <button class="btn sp-button-02 sp-button-sm" type="button" style="float: right; line-height:1.2;" @click="setComponent('reset-edit','')"><i class="fa fa-ban"></i> Cancel</button>
            <!-- <h6>Add New Item </h6> -->
              <!-- <h6>Add New Variation <span v-if="product.product_groups_set_name" style="font-size:13px;">(Set New {{product.product_groups_set_name}})</span></h6> -->
              <h6>Add New Group or Variation</h6>
              <form class="sp-form" style="margin-top:1em; width:100%;" :key="productVariationComponentKey">
                <div class="row">
                  <div v-if="product.product_set_groups > 0" style="width:100%;">
                      <div class="col-md-12">
                          <label class="line-wrap">
                              <input type="radio" v-model="showProductItemGroups" value="showtrue" style="height:1em;">
                                  <!-- Select from previously added <span v-if="product.product_service == 'P'">colours</span>
                                  <span v-if="product.product_service == 'S'">service packages</span> -->
                              Add new Items to <span>{{product.product_groups_set_name}}</span>
                          </label>
                      </div> 
                      <div class="col-md-12">
                          <label class="line-wrap" style="">
                              <input type="radio" v-model="showProductItemGroups" value="showfalse" style="height:1em;">
                                  Or Add new {{product.product_groups_set_name}}
                          </label>
                      </div>
                      <div class="clearfix"></div>
                  </div>
                  <div class="col-md-12">
                    <div v-if="showProductItemGroups == 'showtrue'">
                        <br>
                        <p><b>Select a Group from below:</b></p>
                          <div class="row" v-if="(product.product_item_groups.length && product.product_item_groups.length > 0)" style="width:100%;">
                            <div v-for="(pg,pgdex) in product.product_item_groups" :key="pgdex">
                              <div class="col-xs-2">
                                  <div style="padding:5px; margin-bottom:5px; width:10%">
                                      <a :title="pg.product_item_group_name" style="cursor:pointer;" @click="setInnerComponent('set-product-item-group',pg)">
                                      <div v-if="pg.product_item_group_is_color_image == 'IMG'">
                                          <div class="box-color-cube">
                                              <img :src="pg.product_item_group_image" :id="pg.product_item_group_id+'PRTGR'" class="product-item-group sp-prd-img" style=""/>
                                          </div>
                                      </div>
                                      <div v-if="pg.product_item_group_is_color_image == 'COL'">
                                          <div :id="pg.product_item_group_id+'PRTGR'" class="product-item-group">
                                              <div class="box-color-cube" v-bind:style="{background: pg.product_item_group_color}"  style="height:3em; width:85%;"></div>
                                          </div>
                                      </div>
                                      <p style="color:#000000; font-weight:bold; font-size:12px; line-height:1.2; text-align: center;">{{pg.product_item_group_name}}</p>
                                      </a>
                                  </div> 
                                </div>
                            </div>
                              <div class="clearfix"></div>
                          </div>
                    </div>
                    <div v-if="showProductItemGroups == 'showfalse'">
                        <br>
                        <div class="form-group">
                          <label style="font-size: 16px;">Name of new {{product.product_groups_set_name}} <br><span style="font-size: 13px;">(eg:Blue,Black,Custom,Anyname..)</span>
                          <input type="text" v-model="product.product_item_group_name" class="form-control" @change="(productVariationComponentKey++)"></label>
                        </div>
                        <div class="form-group">
                          <label class="col-xs-12" style="font-size: 16px; margin: 0; padding: 0;">Group Colour/Image</label>
                          <!-- <label> Pick Colour or Pick from uploaded Images to match the colour you are adding</label> -->
                          <label class="col-xs-4" style="margin: 0; padding: 0;">
                            <input type="radio" name='prt-color-image' @click="toggleDoubleComponent('prt-color','prt-image')" value="colour" style="height:1em;">
                            Colour
                          </label>
                          <label class="col-xs-4" style="margin: 0; padding: 0;">
                            <input type="radio" name='prt-color-image' @click="toggleDoubleComponent('prt-image','prt-color')" value="image" style="height:1em;">
                            Image
                          </label>
                        </div>
                        <div class="form-group" id="prt-color" style="clear:both; display: none;  padding:1em;">
                          <label style="font-size:12px;"> Pick Colour
                            <input type="color" v-model="product.product_item_group_color"  class="form-control" style="width:4em;">
                          </label>
                        </div>
                        <div class="form-group" id="prt-image" style="clear:both; display: none; border:1px dashed #eeccee; padding:1em;">
                            <label style="font-size:12px;"> Or Pick Image <!-- Or Pick Images/Videos--> </label>
                            <div class="row img-row">
                                <div id="groupImage" class="col-xs-1" v-for="(img,index) in product.product_images" :key="index" style="height:50px; width:70px;">
                                <a style="cursor:pointer;" @click="setInnerComponent('set-product-item-group-image',img.product_image_id)">
                                    <img :id="img.product_image_id+'PRTG'" class="product-item-group-image sp-prd-img" :src="img.product_image"  alt="">
                                    </a>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <!-- <hr/> -->
                            
                            <div style="z-index:9;">
                              <p class="p-tiny-info">{{max_media_info}}</p>
                                  <div class="upload-btn-wrapper" style="cursor:pointer; margin-top: 2em;">
                                    <button type="button" class="sp-button-02 sp-button-sm">Or Add new Image or Video </button>
                                    <input type="file" id="input-file" @change="onFileChangeProductItems($event,'products',product.product_id)" accept="video/*,image/*" capture/>
                                  </div>
                                <div v-if="action_loading" class="loading-sm"></div>
                              <p class="data-error-message">{{data_media_error_message}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <br>       
                  </div>
                  <div :key="productAddView02ComponentKey" class="row col-md-12" v-if="(showProductItemGroups == 'showtrue') || (showProductItemGroups == 'showfalse')">
                    <!--other-attributes--> 
                    <!-- <div class="col-md-12"><label><h4 style="font-size:14px;">Enter Details of New Group Item</h4></label></div> -->
                      <div class="col-xs-12">
                        <!-- <label class="sp-app-default-text-color-dim-1" style="color:#898989;">Add details of an Item in Group -->
                        <label class="sp-app-default-text-color-dim-1" style="color:#898989;">Add an Item to this Group
                          <span v-if="product.product_item_group_name && (product.product_item_group_name != '')">
                          : (<b>{{product.product_item_group_name}}</b>)</span>
                          <span v-if="product.product_service == 'P'">(eg:sizes,lengths,materials)</span>
                        </label>
                      </div>

                      <div class="col-xs-12" v-if="product.product_service == 'P'" style="margin-bottom: 1em;">
                        <!-- <label class="sp-app-default-color">Name this item if you want to</label> -->
                        <label>Name of item / Describe product <br>(eg:big,long,short,xl,m...)</label> 
                        <input type="text" v-model="product.product_item_size"  placeholder="" class="form-control">
                      </div>
                      <!-- <div class="col-md-12 col-xs-12" v-if="product.product_service == 'P'" style="margin-top:1em;">
                        <label>Attributes (eg: Size, Plan, Length etc,)
                          <input type="text" v-model="product.product_item_size"  placeholder="" class="form-control">
                        </label>
                      </div> -->

                      <div class="row" v-if="product.product_service == 'P'" style="padding:1em; display: none;">
                        <!-- <label>Attributes (eg: Size, Plan, Length etc,)</label> -->
                        <div class="col-xs-5"> 
                        {{product.product_groups_items_set_name}}<br>(eg:sizes,lengths,materials)
                          <!-- <input type="text" v-model="product.product_item_size"  placeholder="" class="form-control">  -->
                        </div>
                        <div class="col-xs-1"> - </div>
                        <div class="col-xs-4">
                          (eg:big,long,short,xl,m...)<br>  
                          <input type="text" v-model="product.product_item_size"  placeholder="" class="form-control">
                        </div>
                      </div>
                      
                      <div class="col-md-3 col-xs-6" v-if="product.product_service == 'S'">
                        <label> Service Tag <input type="text" v-model="product.product_item_service_tag"  placeholder="" class="form-control">
                        </label>
                      </div>
                      
                      <div class="col-md-3 col-xs-6">
                        <label> Price
                          <input type="number" v-model="product.product_item_price" value="" placeholder="" class="form-control">
                        </label>
                      </div>

                      <div class="col-md-3 col-xs-6" v-if="product.product_service == 'S'">
                        <label> Duration <span class="sp-info-sm">eg: 3 months</span> </label>
                        <table style="width: 100%;"><tr>
                          <td style="width: 30%;">
                            <input type="number" style="width: 100%;" v-model="product.product_item_service_duration" placeholder="" class="form-control">
                          </td>
                          <td style="width: 70%;">
                            <select v-model="service_duration" class="form-control">
                              <option :value="undefined">Select</option>
                              <option>days</option>
                              <option>months</option>
                              <option>years</option>
                            </select>
                        </td>
                        </tr></table>
                      </div>
                      
                      <div class="col-md-3 col-xs-3" v-if="product.product_service == 'P'">
                          <label> Weight(KG)
                              <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" class="form-control">
                          </label>
                      </div>

                      <div class="col-md-3 col-xs-3" v-if="product.product_service == 'P'">
                          <label> Quantity
                              <input type="number" v-model="product.product_item_quantity"  placeholder="" class="form-control">
                          </label>
                      </div>

                      <div class="col-md-12 col-xs-12" style="margin-top: 1em;">
                          <p class="data-error-message">{{data_error_message}}</p>
                          <p class="data-success-message">{{data_success_message}}</p>
                          <div v-if="action_loading" class="loading-sm"></div>
                          <button :disabled="disable_btn" type="button" class="btn sp-button-02" @click="addProductItem">Add</button>
                          <button class="btn sp-button-02" @click="setComponent('reset-edit','')">Cancel</button>
                      </div>
                  </div>
                </div>
              </form>
          </div>
          <!--./add-product-variation-->
          <div class="clearfix"></div>
        </div>
    </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }

    }
</script>


// WEBPACK FOOTER //
// ProductTypes.vue?6007e7d4